module.exports = __webpack_public_path__ + "img/11.78447c16.jpg";